(function WorkflowModifyController() {
    'use strict';

    angular.module('Workflow')
        .controller('WorkflowModifyController', [
            '$scope', 'config', '$state', '$stateParams', '$translate', 'errorsExtend', 'authExtend', 'workflowService', '$filter',
            function workflowController($scope, config, $state, $stateParams, $translate, errors, authExtend, workflowService, $filter) {

                $scope.hasMetadatas = false;
                $scope.assigned = true;

                $scope.load = function () {
                    workflowService.getTask($stateParams.id, "global").then(function (result) {
                        $scope.task = result.value;
                        $scope.creationDate = $filter('date')($scope.task.createTime, 'dd/MM/yyyy');
                        $scope.task.metadatas = [];
                        $scope.assigned = $scope.task.assignee != null;

                        $scope.task.formProperty.formProperties.forEach(function (prop) {
                            var type = prop.type === 'enum' ? 'combo' : prop.type === 'long' ? 'number' : prop.type;

                            prop.metadataOptions = [];

                            if (type === 'combo') {
                                prop.enumValues.forEach(function (enu) {
                                    var metadataOption = {
                                        value: undefined,
                                        desc: undefined
                                    }
                                    metadataOption.value = enu.id;
                                    metadataOption.desc = enu.name;

                                    prop.metadataOptions.push(metadataOption);
                                });
                            }

                            $scope.task.metadatas.push(
                                {
                                    metadataId: prop.id,
                                    metadataValue: prop.value,
                                    metadataType: type,
                                    metadataLabel: prop.name,
                                    metadataReadOnly: false,
                                    metadataOptions: type === 'combo' ? prop.metadataOptions : undefined
                                });
                        });

                        $scope.hasMetadatas = $scope.task.metadatas.length !== 0;

                    }, function (error) {
                        errors.showError(error);
                        $state.go('workflow-find');
                    });
                }

                $scope.claimTask = function (selectedTask) {
                    workflowService.claimTask(selectedTask).then(function (result) {
                        errors.showSuccess('WorkFlowClaimSuccess');
                        $scope.assigned = true;
                        $scope.task.assignee = result.value;
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.cancel = function () {
                    $state.go('workflow-find');
                };

                $scope.sendTask = function () {
                    var taskAction = {
                        variables: [],
                        action: "complete",
                        taskId: $scope.task.id
                    }

                    $scope.task.metadatas.forEach(function (meta) {
                        taskAction.variables.push({ name: meta.metadataId, value: meta.metadataValue });
                    });

                    workflowService.sendTask(taskAction).then(function (result) {
                        $state.goBack();
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.load();
            }
        ]);
})();